// Protected route wrapper - kimlik dogrulamasi gerektiren sayfalar icin
// Giris yapmamis kullanicilar /login'e yonlendirilir
// returnUrl parametresi ile giris sonrasi orijinal sayfaya donus yapilir
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
}

export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, user, isLoading } = useAuth()
  const location = useLocation()

  console.log('🛡️ ProtectedRoute:', {
    isAuthenticated,
    user: user?.display_name,
    isLoading,
    path: location.pathname
  })

  // Loading state - bekle
  if (isLoading) {
    console.log('⏳ ProtectedRoute: Loading...')
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>Loading...</div>
  }

  // Giris yapmamis kullanici - login'e yonlendir
  if (!isAuthenticated) {
    console.log('❌ ProtectedRoute: Not authenticated, redirecting to login')
    // returnUrl parametresi ile giris sonrasi orijinal sayfaya donus
    const returnUrl = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />
  }

  // Admin kontrolu - sadece admin kullanicilar erisebilir
  if (requireAdmin && user?.role !== 'admin' && user?.role !== 'both') {
    console.log('❌ ProtectedRoute: Not admin, redirecting to home')
    // Admin degil - ana sayfaya yonlendir
    return <Navigate to="/" replace />
  }

  console.log('✅ ProtectedRoute: Access granted')
  // Yetkilendirilmis - sayfa icerigini goster
  return <>{children}</>
}
